// components
import CommonActionModal from "../Common/CommonActionModal";
import TableViewIcon from "@mui/icons-material/TableView";
import SearchInner from "./SearchInner";

//icons
import SearchIcon from '@mui/icons-material/Search';


class Search extends CommonActionModal {
    async componentDidMount() {
        this.setState({
            buttonIcon: SearchIcon,
            buttonColor: 'neutral',
            flat: true,
            ready: true,
        })
    }

    async beforeModalOpen(){
        return {
            modalLabel: 'Поиск',
            modalIcon: TableViewIcon,
            mainComponent: SearchInner,
            mainComponentProps: {
                callBack: this.setModalOpenFalse.bind(this)
            },
        }
    }
}

export default Search